
















































import { Component, Vue } from "vue-property-decorator";
import router from "../router";
import store, { modules } from "../store";
import { INouvelleLocation, NouvelleLocation } from "../models/Location";
import { MLink } from "@ulaval/modul-components";
import DelaiLocationPlugin from "../plugins/delai";

@Component({ components: { MLink } })
export default class Test extends Vue {
  private listeEtapesTest: string[] = [];

  protected async mounted(): Promise<void> {
    // eslint-disable-next-line no-console
    console.log(
      "location; délai dépassé : " +
        (DelaiLocationPlugin.isDelaiLocationDepasse() ? "oui" : "pas encore")
    );

    await store.dispatch(modules.cds.actions.recupererTypesClientele.name, {
      vm: this,
    });
    this.listeEtapesTest.push("Récupération des types de clientèle");

    store.commit(
      modules.utilisateur.mutations.sauvegarderTypeClientele.name,
      store.state.cds.typesClientele[0]
    );
    this.listeEtapesTest.push(
      "Sauvegarde du type " +
        (store.state.utilisateur.typeClientele?.nomTypeClientele || "")
    );

    await store.dispatch(modules.cds.actions.recupererPeriodes.name, {
      typePeriodeId: store.state.utilisateur.typeClientele?.typePeriodeId || "",
      vm: this,
    });
    this.listeEtapesTest.push("Récupération des périodes");

    store.commit(
      modules.utilisateur.mutations.sauvegarderPeriode.name,
      store.state.cds.periodes[0]
    );
    this.listeEtapesTest.push(
      "Sauvegarde de la période " +
        (store.state.utilisateur.periode?.nomPeriode || "")
    );

    await store.dispatch(
      modules.cds.actions.recupererPavillonsAvecCasiersDispos.name,
      {
        cleDispo: store.state.applicatif.variableEnvCleOptionCasierDisponible,
        idUtilisateur: this.$msal.data.query.profile?.id || "",
        vm: this,
      }
    );
    this.listeEtapesTest.push("Récupération des pavillons");

    store.commit(
      modules.utilisateur.mutations.sauvegarderPavillon.name,
      store.state.cds.pavillons[0]
    );
    this.listeEtapesTest.push(
      "Sauvegarde du pavillon " +
        (store.state.utilisateur.pavillon?.nomPavillon || "")
    );

    await store.dispatch(
      modules.cds.actions.recupererNiveauxAvecCasiersDispos.name,
      {
        pavillonId: store.state.utilisateur.pavillon?.id || "",
        cleDispo: store.state.applicatif.variableEnvCleOptionCasierDisponible,
        idUtilisateur: this.$msal.data.query.profile?.id || "",
        vm: this,
      }
    );
    this.listeEtapesTest.push("Récupération des niveaux");

    store.commit(
      modules.utilisateur.mutations.sauvegarderNiveau.name,
      store.state.cds.niveaux[0]
    );
    this.listeEtapesTest.push(
      "Sauvegarde du niveau " +
        (store.state.utilisateur.niveau?.nomNiveau || "")
    );

    await store.dispatch(
      modules.cds.actions.recupererCasiersDisposEtBonEtatParNiveau.name,
      {
        niveauId: store.state.utilisateur.niveau?.id || "",
        cleDispo: store.state.applicatif.variableEnvCleOptionCasierDisponible,
        idUtilisateur: this.$msal.data.query.profile?.id || "",
        vm: this,
      }
    );
    this.listeEtapesTest.push("Récupération des casiers");

    store.commit(
      modules.utilisateur.mutations.sauvegarderCasier.name,
      store.state.cds.casiers[0]
    );
    this.listeEtapesTest.push(
      "Sauvegarde du casier " + (store.state.utilisateur.casier?.numero || "")
    );

    store.commit(
      modules.utilisateur.mutations.sauvegarderMontant.name,
      store.state.utilisateur.periode?.tarifLocation || 0
    );
    this.listeEtapesTest.push(
      "Sauvegarde du montant (sans taxe) " +
        (store.state.utilisateur.periode?.tarifLocation || "0")
    );

    const detailsLocation: INouvelleLocation = {
      si_tps: store.state.utilisateur.periode?.tauxTPS || 0,
      si_tvq: store.state.utilisateur.periode?.tauxTVQ || 0,
      si_total: store.state.utilisateur.montant,
      si_tariflocation: store.state.utilisateur.periode?.tarifLocation || 0,
      si_acceptationconditionslocation: true,
      si_adressedecourriel: this.$msal.data.query.profile?.mail || "",
      si_prenomdulocateur: this.$msal.data.user?.name || "",
      si_nomdulocateur: this.$msal.data.user?.name || "",
      si_identifiant_locateur: this.$msal.data.query.profile?.id || "",
      typeClienteleId: store.state.utilisateur.typeClientele?.id || "",
      casierId: store.state.utilisateur.casier?.id || "",
      niveauId: store.state.utilisateur.niveau?.id || "",
      pavillonId: store.state.utilisateur.pavillon?.id || "",
      periodeId: store.state.utilisateur.periode?.id || "",
    };
    const nouvelleLocation = new NouvelleLocation(detailsLocation);

    store.commit(
      modules.utilisateur.mutations.creerNouvelleLocationSucces.name,
      nouvelleLocation
    );
    this.listeEtapesTest.push(
      "Sauvegarde de la nouvelle location (sans le POST vers le CDS)"
    );
  }

  private effectuerMenage(): void {
    store.commit(modules.minuteur.mutations.effacerStateMinuteur.name);
    store.commit(modules.utilisateur.mutations.effacerStateUtilisateur.name);

    this.listeEtapesTest.push("Ménage effectué");
  }

  private viderMsal(): void {
    this.$msal.data.user = undefined;
  }

  private allerAccueil(): void {
    router.push({ name: "Accueil" });
  }

  get nomTypeClientele(): string {
    return store.state.utilisateur.typeClientele?.nomTypeClientele || "";
  }

  get nomPeriode(): string {
    return store.state.utilisateur.periode?.nomPeriode || "";
  }

  get nomPavillon(): string {
    return store.state.utilisateur.pavillon?.nomPavillon || "";
  }

  get nomNiveau(): string {
    return store.state.utilisateur.niveau?.nomNiveau || "";
  }

  get numeroCasier(): string {
    return store.state.utilisateur.casier?.numero || "";
  }

  get prenom(): string {
    return this.$msal.data.query.profile?.givenName || "";
  }

  get nomFamille(): string {
    return this.$msal.data.query.profile?.surname || "";
  }

  get courriel(): string {
    return (
      store.state.utilisateur.courriel ||
      this.$msal.data.query.profile?.mail ||
      ""
    );
  }

  get informationsLocationValides(): boolean {
    return (
      store.state.utilisateur.typeClientele != undefined &&
      store.state.utilisateur.periode != undefined &&
      store.state.utilisateur.pavillon != undefined &&
      store.state.utilisateur.niveau != undefined &&
      store.state.utilisateur.casier != undefined
    );
  }

  get informationsUtilisateurValides(): boolean {
    return this.$msal.data.query.profile != undefined;
  }

  get informationsValides(): boolean {
    return (
      this.informationsLocationValides && this.informationsUtilisateurValides
    );
  }
}
